import { Role } from './role';
import { Permission } from './permission';

export class User {
    constructor(
        public id = 0,
        public idnumber = '',
        public username = '',
        public first_name = '',
        public last_name = '',
        public email = '',
        public phone = '',
        public cellphone = '',
        public address = '',
        public mobile_session_enabled = 1,
        public state = 1,
        public role = new Role(),
        public is_system: number = 0
    ) {}

    get name() {
        return this.first_name + ' ' + this.last_name;
    }
    static fromJSON(data: any): User {
        const permissions = Array.isArray(data?.role?.permissions)
            ? data.role.permissions.map((permission: any) => new Permission(
                permission.id,
                permission.name,
                permission.action ?? '',
                permission.menu?.route ?? ''
            ))
            : [];

        const role = new Role(
            data?.role?.id ?? 0,
            data?.role?.name ?? '',
            permissions
        );
        return new User(
            data?.id ?? 0,
            data?.idnumber ?? '',
            data?.username ?? '',
            data?.first_name ?? '',
            data?.last_name ?? '',
            data?.email ?? '',
            data?.phone ?? '',
            data?.cellphone ?? '',
            data?.address ?? '',
            data?.mobile_session_enabled ?? 1,
            data?.state ?? 1,
            role,
            data?.is_system ?? 0
        );
    }    
}
